import { createContext } from 'react';

import newGroupBubble from '../../../utils/audio/newGroupBubble.wav';

import { useBonkBubbles } from '../hooks/useBonkBubbles';
import { isBonkSoundMuted } from '../localStorage';

const newGroupBubbleSound = new Audio(newGroupBubble);

export const BonkBubblesContext = createContext<ReturnType<typeof useBonkBubbles>>([
    {
        get: () => ({
            bubbles: [],
            loading: null,
        }),
        subscribe: () => () => {},
    },
    () => {},
]);

export const BonkBubblesProvider = ({ enabled, children }: React.PropsWithChildren<{ enabled: boolean }>) => {
    const bonk = useBonkBubbles({
        enabled,
        onNewBubble: () => {
            if (!isBonkSoundMuted()) {
                newGroupBubbleSound.play().catch((e) => console.warn('Sound play failed:', e));
            }
        },
    });

    return <BonkBubblesContext.Provider value={bonk}>{children}</BonkBubblesContext.Provider>;
};
